<script>
import Alerts from "@/components/Alerts.vue";

export default {
    name: "FileUpload",
    components: {Alerts},
    props: ['code'],

    data() {
        return {
            axios: this.$http,
            base_url: "",

            selectedFiles: [],
            selectedFilesList: [],
            allowed_files: ".xls, .xlsx, .csv, .jpg, .jpeg, .png, .gif, .pdf",

            progress: 0,
            documents: [],
            list_view: false
        }
    },
    mounted() {
        this.loadDocuments()
    },
    methods: {
        loadDocuments() {
            this.wait = true
            this.clear()
            this.axios.get(`${this.base_url}/request/${this.code}/docs`).then(response => {
                this.documents = response.data.data
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        },
        handleFileSelection(event) {
            this.selectedFiles = event.target.files;
            if (this.selectedFiles) {
                for (let i = 0; i < this.selectedFiles.length; i++) {
                    let file = this.selectedFiles[i];
                    if (!this.selectedFilesList.some(f => f.name === file.name)) {
                        file.sizeMb = (file.size / (1024 * 1024)).toFixed(2)
                        file.previewURL = URL.createObjectURL(file)
                        this.selectedFilesList.push(file);
                    }
                }
                this.selectedFiles = null;
                this.$refs.fileInput.value = null;
            }
        },
        removeFileFromList(index) {
            this.selectedFilesList.splice(index, 1);
        },
        deleteDoc(doc) {
            if (confirm(`Delete this document? ${doc.title}`)) {
                this.axios.post(`${this.base_url}/request/${this.code}/docs`, {
                    delete_id: doc.id
                }).then(() => {
                    this.loadErp()
                }).catch(error => {
                    this.showError(error)
                })
            }
        },
        uploadFiles() {
            this.wait = true
            let formData = new FormData()
            for (let i = 0; i < this.selectedFilesList.length; i++) {
                formData.append('files[' + i + ']', this.selectedFilesList[i])
            }

            this.axios.post(`${this.base_url}/request/${this.code}/docs`, formData, {
                headers: {'Content-Type': 'multipart/form-data'},
                onUploadProgress: function (e) {
                    this.progress = parseInt(Math.round((e.loaded * 100) / e.total))
                }.bind(this)
            }).then(() => {
                this.progress = 0
                this.success = "Files uploaded successfully."
                this.selectedFiles = []
                this.selectedFilesList = []
                this.loadDocuments()

            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.wait = false
            })
        },
        totalSize() {
            let total = this.documents.reduce((sum, doc) => {
                return sum += parseFloat(doc.size);
            }, 0);
            return !isNaN(total) ? parseFloat(total.toFixed(2)) : 0;
        }
    }
}
</script>

<template>
    <div class="p-4 bg-white shadow-sm rounded-lg mb-3">
        <section class="mb-5">
            <h5 class="font-weight-bold">File Upload</h5>
            <p>Attach and upload any receipts available for this ERP</p>

            <Alerts :_error="error" :_success="success" :_loading="wait"></Alerts>

            <div class="custom-file mb-2">
                <input type="file" class="custom-file-input" ref="fileInput"
                        @change="handleFileSelection"
                        multiple
                        id="customFile"
                        size="10485760"
                        :accept="allowed_files">
                <!-- Max file input 10MB-->

                <label class="custom-file-label" for="customFile">Select files to upload</label>
            </div>
            <p class="text-muted">Allowed files {{ allowed_files }} | Max size 10MB</p>

            <!-- Display files -->
            <section>
                <p v-if="selectedFilesList.length">You have selected the following files for upload</p>
                <div class="row d-flex">
                    <div v-for="(file, index) in selectedFilesList" :key="index"
                            class="col-md-4 d-flex align-items-stretch">
                        <div class="border mb-3 rounded-sm p-2 text-center">
                            <div class="small text-muted mb-3">
                                <input v-model="file.name" class="form-control" placeholder="Rename file">

                                Size {{ file.sizeMb }} MB <br>
                                <div class="my-2">
                                    <a href="#" class="text-danger" @click="removeFileFromList(index)">Remove</a>
                                </div>
                            </div>

                            <img v-if="file.type.startsWith('image')"
                                    :src="file.previewURL" style="max-width: 100%; max-height: 180px;"
                                    class="rounded-sm shadow-sm"
                                    alt="Preview">

                            <embed v-else-if="file.type === 'application/pdf'" :src="file.previewURL"
                                    width="100%" style="max-height: 220px" type="application/pdf">

                            <span v-else>{{ file.name }}</span>
                        </div>
                    </div>
                </div>
            </section>
            <!-- End of file display -->

            <button class="btn" @click="uploadFiles()"
                    :disabled="wait || !selectedFilesList.length">
                <span v-if="wait">Please wait...</span>
                <span v-else>Upload Selected</span>
            </button>

        </section>


        <div class="custom-control custom-switch" style="float: right">
            <input type="checkbox" v-model="list_view" class="custom-control-input" id="list-view">
            <label class="custom-control-label" for="list-view">List View</label>
        </div>
        <h5 class="font-weight-bold">
            Documents 
            <span>({{ documents.length}})</span>
        </h5>

        <div v-if="!list_view" class="row mt-4">
            <div v-for="doc in documents" :key="doc.id" class="col-md-4 mb-3">
                <div class="shadow-sm rounded-lg d-flex flex-column h-100">
                    <div class="flex-fill d-flex  flex-column mb-2">
                        <div class="flex-fill">
                            <a :href="doc.url" target="_blank">
                                <img v-if="doc.type=='img'" :src="doc.url" style="width: 100%"/>

                                <embed v-else-if="doc.type=='pdf'" :src="doc.url"
                                        width="100%" style="min-height: 280px" type="application/pdf">

                                <div v-else>No preview</div>
                            </a>
                        </div>
                        <div class="bg-light p-2">
                            <h6 class="small mt-2 font-weight-bold" style="color: inherit">
                                <a :href="doc.url" target="_blank">{{ doc.title }}</a>
                            </h6>
                            <div class="small">
                                <div>{{ day(doc.created_at).format('MMM DD, YYYY') }}</div>
                                <div>{{ doc.path }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="p-2">
                        <div>
                            <button class="btn btn-outline-danger btn-sm" v-if="!doc.system_doc"
                                    @click="deleteDoc(doc)">Delete
                            </button>&nbsp;
                            <span v-if="doc.system_doc" class="status">system generated file</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <table v-else class="table table-bordered table-sm mb-2">
            <thead>
            <tr>
                <th>Code</th>
                <th>File Name</th>
                <th>Path</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="doc in documents" :key="doc.id">
                <td>{{ doc.id }}</td>
                <td :class="doc.system_doc ? 'font-weight-bold' : ''"><a :href="doc.url"
                                                                            target="_blank">{{ doc.title }}</a></td>
                <td>{{ doc.path }}</td>
                <td>
                    <button class="btn btn-outline-danger btn-sm" v-if="!doc.system_doc" @click="deleteDoc(doc)">
                        Delete
                    </button>
                    <span v-if="doc.system_doc" class="status">system generated</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped>
.row.g-1 {
    margin-left: -0.5rem; /* Adjust the negative margin to reduce the gap */
    margin-right: -0.5rem;
}

</style>